{
  "title": "Faktaboks",
  "factboxDocument": "Faktaboks dokument",
  "lockedToArticle": "Låst til artikkel",
  "fromPublished": "Låst til publisert",
  "article": "artikkel",
  "original": "original",
  "action": {
    "createFactbox": "Ny faktaboks",
    "open": "Åpne"
  },
  "usedInArticles": "Brukes i artikler",
  "previousPage": "Forrige",
  "nextPage": "Neste",
  "outOfSync": "Er endret",
  "outOfSyncTooltip": "Innholdet i faktaboksen i denne artikkelen skiller seg fra originalen",
  "inSync": "Samsvarer",
  "inSyncTooltip": "Innholdet i faktaboksen i denne artikkelen samsvarer med originalen",
  "prompts": {
    "approveBeforeClose": "Vil du godkjenne endringene før du lukker?",
    "savedButNotApproved": "Endringene er lagret, men faktaboksen er ikke godkjent."
  }
}
